import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { ComponentFactory } from "../Components/ComponentFactory";

//  _______________
// |     |    |    |
// |_____|____|____|
// |               |
// |_______________|
// |               |
// |               |
// |_______________|
// |               |
// |_______________|
// |       |       |
// |_______|_______|

class Layout12 extends Component {
  render() {
    const {
      selectedComponent,
      layoutData: { components },
      componentsBackground,
      isResponsive,
      isPresentation
    } = this.props;

    const customBackground = {
      background: componentsBackground
    };

    return (
      <div className={`${styles.layout}`}>
        <div
          className={`large-12 medium-12 small-12 ${styles.component_block}`}
        >
          <div className={`${styles.flex_container}`}>
            <div
              className={classnames(
                isResponsive ? "large-6 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container
              )}
              style={{ height: "500" }}
            >
              <div
                className={`large-12 medium-12 small-12 ${
                  styles.component_block
                }`}
              >
                <div className={`${styles.flex_container}`}>
                  <div
                    className={classnames(
                      isResponsive ? "large-4 medium-12 small-12" : "small-4",
                      styles.component_block,
                      styles.flex_container,
                      styles.align_container,
                      isPresentation &&
                        (selectedComponent === components[2].componentId
                          ? styles.gradient_border
                          : "")
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height
                      )}
                      style={customBackground}
                    >
                      {/********** Component n°1 ********/}
                      <ComponentFactory
                        component={components[2]}
                        layoutProps={{ customBackground: customBackground }}
                      />
                    </div>
                  </div>
                  <div
                    className={classnames(
                      isResponsive ? "large-4 medium-12 small-12" : "small-4",
                      styles.component_block,
                      styles.flex_container,
                      styles.align_container,
                      isPresentation &&
                        (selectedComponent === components[3].componentId
                          ? styles.gradient_border
                          : "")
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height
                      )}
                      style={customBackground}
                    >
                      {/********** Component n°1 ********/}
                      <ComponentFactory
                        component={components[3]}
                        layoutProps={{ customBackground: customBackground }}
                      />
                    </div>
                  </div>
                  <div
                    className={classnames(
                      isResponsive ? "large-4 medium-12 small-12" : "small-4",
                      styles.component_block,
                      styles.flex_container,
                      styles.align_container,
                      isPresentation &&
                        (selectedComponent === components[4].componentId
                          ? styles.gradient_border
                          : "")
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_m_height
                      )}
                      style={customBackground}
                    >
                      {/********** Component n°1 ********/}
                      <ComponentFactory
                        component={components[4]}
                        layoutProps={{ customBackground: customBackground }}
                      />
                    </div>
                  </div>
                  <div
                    className={classnames(
                      isResponsive ? "large-12 medium-12 small-12" : "small-12",
                      styles.component_block,
                      styles.flex_container,
                      styles.align_container,
                      isPresentation &&
                        (selectedComponent === components[5].componentId
                          ? styles.gradient_border
                          : "")
                    )}
                  >
                    <div
                      className={classnames(
                        styles.component_container,
                        styles.container_l_height
                      )}
                      style={customBackground}
                    >
                      {/********** Component n°2 ********/}
                      <ComponentFactory
                        component={components[5]}
                        layoutProps={{
                          customBackground: customBackground,
                          scaleComponent: true,
                          containerHeight: 300
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-6 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isPresentation &&
                  (selectedComponent === components[1].componentId
                    ? styles.gradient_border
                    : "")
              )}
              style={{ height: "500" }}
            >
              <div
                className={
                  classnames(styles.component_container)
                  //   styles.container_m_height
                }
                style={customBackground}
              >
                {/********** Component n°1 ********/}
                <ComponentFactory
                  component={components[1]}
                  layoutProps={{ customBackground: customBackground }}
                />
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-6 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  isResponsive ? "large-4 medium-12 small-12" : "small-4",
                  styles.component_block,
                  styles.flex_container,
                  styles.align_container,
                  isPresentation &&
                    (selectedComponent === components[6].componentId
                      ? styles.gradient_border
                      : "")
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height
                  )}
                  style={customBackground}
                >
                  {/********** Component n°2 ********/}
                  <ComponentFactory
                    component={components[6]}
                    layoutProps={{
                      customBackground: customBackground,
                      scaleComponent: true,
                      containerHeight: 300
                    }}
                  />
                </div>
              </div>
              <div
                className={classnames(
                  isResponsive ? "large-4 medium-12 small-12" : "small-4",
                  styles.component_block,
                  styles.flex_container,
                  styles.align_container,
                  isPresentation &&
                    (selectedComponent === components[7].componentId
                      ? styles.gradient_border
                      : "")
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height
                  )}
                  style={customBackground}
                >
                  {/********** Component n°2 ********/}
                  <ComponentFactory
                    component={components[7]}
                    layoutProps={{
                      customBackground: customBackground,
                      scaleComponent: true,
                      containerHeight: 300
                    }}
                  />
                </div>
              </div>
              <div
                className={classnames(
                  isResponsive ? "large-4 medium-12 small-12" : "small-4",
                  styles.component_block,
                  styles.flex_container,
                  styles.align_container,
                  isPresentation &&
                    (selectedComponent === components[8].componentId
                      ? styles.gradient_border
                      : "")
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height
                  )}
                  style={customBackground}
                >
                  {/********** Component n°2 ********/}
                  <ComponentFactory
                    component={components[8]}
                    layoutProps={{
                      customBackground: customBackground,
                      scaleComponent: true,
                      containerHeight: 300
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-6 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container
              )}
            >
              <div
                className={classnames(
                  isResponsive ? "large-6 medium-12 small-12" : "small-6",
                  styles.component_block,
                  styles.flex_container,
                  styles.align_container,
                  isPresentation &&
                    (selectedComponent === components[9].componentId
                      ? styles.gradient_border
                      : "")
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height
                  )}
                  style={customBackground}
                >
                  {/********** Component n°2 ********/}
                  <ComponentFactory
                    component={components[9]}
                    layoutProps={{
                      customBackground: customBackground,
                      scaleComponent: true,
                      containerHeight: 300
                    }}
                  />
                </div>
              </div>
              <div
                className={classnames(
                  isResponsive ? "large-6 medium-12 small-12" : "small-6",
                  styles.component_block,
                  styles.flex_container,
                  styles.align_container,
                  isPresentation &&
                    (selectedComponent === components[10].componentId
                      ? styles.gradient_border
                      : "")
                )}
              >
                <div
                  className={classnames(
                    styles.component_container,
                    styles.container_l_height
                  )}
                  style={customBackground}
                >
                  {/********** Component n°2 ********/}
                  <ComponentFactory
                    component={components[10]}
                    layoutProps={{
                      customBackground: customBackground,
                      scaleComponent: true,
                      containerHeight: 300
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout12;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/Layout12.js